import React, { useEffect, useState, useRef } from 'react';

function MediaModal({ mediaUrl, posterUrl, onClose }) {
  const isVideo = /\.(mp4|webm|ogg|mov|avi|mkv)$/i.test(mediaUrl);
  const videoRef = useRef(null);
  const [videoDimensions, setVideoDimensions] = useState(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  // When mediaUrl changes, reset videoDimensions
  useEffect(() => {
    setVideoDimensions(null);
  }, [mediaUrl]);

  // Handle loaded metadata for video to get natural size
  const handleLoadedMetadata = () => {
    if (videoRef.current) {
      setVideoDimensions({
        width: videoRef.current.videoWidth,
        height: videoRef.current.videoHeight,
      });
    }
  };

  if (!mediaUrl) return null;

  // Default modal style constraining max size
  let modalStyle = {
    maxHeight: '90vh',
    maxWidth: '90vw',
    borderRadius: '10px',
    boxShadow: '0 0 10px black',
    backgroundColor: '#000',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px',
    overflow: 'auto',
  };

  // If video dimensions known, adjust modal size based on aspect ratio & viewport
  if (isVideo && videoDimensions) {
    const viewportWidth = window.innerWidth * 0.9;
    const viewportHeight = window.innerHeight * 0.9;
    const videoRatio = videoDimensions.width / videoDimensions.height;
    const viewportRatio = viewportWidth / viewportHeight;

    // Decide whether to limit by width or height
    if (videoRatio > viewportRatio) {
      // Video is wider relative to viewport — limit by width
      modalStyle = {
        ...modalStyle,
        width: viewportWidth,
        height: viewportWidth / videoRatio,
      };
    } else {
      // Video is taller relative to viewport — limit by height
      modalStyle = {
        ...modalStyle,
        height: viewportHeight,
        width: viewportHeight * videoRatio,
      };
    }
  }

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.8)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        cursor: 'pointer',
        padding: '10px',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={modalStyle}
      >
        {isVideo ? (
          <video
            ref={videoRef}
            src={mediaUrl}
            controls
            autoPlay
            poster={posterUrl || undefined}
            onLoadedMetadata={handleLoadedMetadata}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              borderRadius: '10px',
              display: 'block',
            }}
          >
            Sorry, your browser doesn't support embedded videos.{' '}
            <a href={mediaUrl}>Download instead</a>.
          </video>
        ) : (
          <img
            src={mediaUrl}
            alt=""
            style={{
              maxHeight: '90vh',
              maxWidth: '90vw',
              borderRadius: '10px',
              display: 'block',
            }}
          />
        )}
      </div>
    </div>
  );
}

export default MediaModal;
